/**
 * A document's fingerprint, the SHA-256 of its exact text, as people read it.
 * Saying "SHA-256" means nothing to most freelancers, so the app calls it the
 * document fingerprint and shows its first 16 characters in groups of four,
 * enough to tell two texts apart and to match a printout to the signed PDF,
 * which carries the full value.
 */

/** What the fingerprint is, for a tooltip or a line under it. */
export const FINGERPRINT_HELP =
    'A code worked out from the exact wording of the document. If any of the text changed, the code would change too, so it shows which text was signed.';

/**
 * @param {string | null | undefined} sha256 - the hex digest
 * @returns {string} e.g. "905F 77B3 C28D 149C", or '' for none
 */
export function shortFingerprint(sha256) {
    if (!sha256) return '';
    return (
        String(sha256)
            .slice(0, 16)
            .toUpperCase()
            .match(/.{1,4}/g)
            ?.join(' ') ?? ''
    );
}
